import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFarmSetting } from "services";

import { useUserContext } from "utils";

import { GET_FARMS, GET_FARM_DETAILS, GET_FARM_SETTINGS, UPDATE_FARM_SETTING } from "consts";

export const useUpdateFarmSetting = () => {
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const farmId = user?.farm.id;

  return useMutation({
    mutationKey: [UPDATE_FARM_SETTING, farmId],
    mutationFn: (data: { item: string; value: string }) => updateFarmSetting(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_SETTINGS, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DETAILS, farmId] });
    },
  });
};
